import { Spinner } from '@dixa/lib-shared-habla';

import s from './retranslateButton.module.scss';

export const RetranslateLoading = (): JSX.Element => {
  return (
    <div className={s.retranslateLoader}>
      <Spinner />
    </div>
  );
};
